import { BLANK_IMAGE } from '../../../design-system/components';

interface PhoneMockupProps {
  src: string;
  alt: string;
  className?: string;
  eager?: boolean;
  /**
   * A media query where the phone is hidden. The screenshot resolves to a
   * blank data URI there, so that width does not download it.
   */
  skipMedia?: string;
}

export default function PhoneMockup({
  src,
  alt,
  className = '',
  eager = false,
  skipMedia,
}: PhoneMockupProps) {
  const screen = (
    <img
      src={src}
      alt={alt}
      loading={eager ? 'eager' : 'lazy'}
      width="382"
      height="854"
      className="w-full h-auto"
    />
  );
  return (
    <div className={`relative mx-auto ${className}`}>
      {/* Phone frame */}
      <div className="relative bg-(--ee-phone-frame) rounded-[2.5rem] p-2 shadow-2xl">
        {/* Notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1/3 h-6 bg-(--ee-phone-frame) rounded-b-2xl z-10" />
        {/* Screen */}
        <div className="relative rounded-[2rem] overflow-hidden bg-(--ee-surface)">
          {skipMedia ? (
            <picture>
              <source media={skipMedia} srcSet={BLANK_IMAGE} />
              {screen}
            </picture>
          ) : (
            screen
          )}
        </div>
      </div>
    </div>
  );
}
